module.exports = __webpack_public_path__ + "static/img/COC2021-21.fbdb7d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-21.jpg
// module id = IlaT
// module chunks = 0